<template>
    <div style="position:absolute;top:0;left:0;width:100%;height:100%;display:flex;flex-direction: column;">
        <el-container class="layout-container-demo" style="height: 100%;">
            <el-header
                style="text-align: left; font-size: 30px; display: inline-block; padding-top: 10px; padding-left: 10%;">
                <el-row :gutter="20">
                    <el-col :span="20">
                        Replace<u>Something</u>
                    </el-col>
                    <!-- 右侧功能按钮 -->
                    <el-col :span="1" style="align-items: right">
                        <div style="display: flex; align-items: center">
                            <el-dropdown trigger="click" @command="changeLanguage">
                                <span class="el-dropdown-link">
                                    <div>
                                        <svg-icon iconClass="language-4" color="#666666"
                                            style="width: 2em;height: 2em" />
                                    </div>
                                </span>
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item command="zh"
                                            :disabled="'zh' === $i18n.locale">简体中文</el-dropdown-item>
                                        <el-dropdown-item command="en"
                                            :disabled="'en' === $i18n.locale">English</el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                            <el-popover :width="400"
                                popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;margin-left: 5px"
                                trigger="click">
                                <template #reference>
                                    <div>
                                        <svg-icon iconClass="info" color="#666666"
                                            style="width: 28px;height: 28px; margin-left: 10px" />
                                    </div>
                                </template>
                                <MarkdownViewer :content="markdownContent" />
                            </el-popover>
                        </div>
                    </el-col>
                </el-row>
            </el-header>


            <!-- <el-aside width="200px">Menu</el-aside> -->
            <el-main style="padding-left: 10%;padding-right: 10%;">
                <el-form :label-position="labelPosition" label-width="80px">
                    <!-- <el-row>
                    <el-col :span="2">
                        <el-button type="primary" @click="mode = 'jdbc'" :style="mode === 'jdbc' ? 'primary' : 'info'"
                            plain>JDBC</el-button>
                    </el-col>
                    <el-col :span="2">
                        <el-button type="primary" @click="mode = 'mybatis'" :style="mode === 'mybatis' ? 'primary' : 'info'"
                            plain>Mybatis</el-button>
                    </el-col>
                </el-row> -->
                    <el-row>
                        <el-button type="success" @click="tryIt">{{ $t('main.tryIt') }}</el-button>
                        <el-button type="primary" @click="submit">{{ $t('main.replace') }}</el-button>
                        <el-popover :visible="historyVisible" placement="right" :width="850" trigger="click">
                            <template #reference>
                                <el-button circle @click="historyVisible = !historyVisible">
                                    <svg-icon iconClass="history" color="#666666" style="width: 25px;height: 25px;" />
                                </el-button>
                            </template>
                            <el-table :data="historyList">
                                <el-table-column width="150" property="date" label="date" />
                                <el-table-column width="300" property="inputParam1" label="Sql" show-overflow-tooltip />
                                <el-table-column width="300" property="inputParam2" :label="$t('main.param')"
                                    show-overflow-tooltip />
                                <el-table-column width="50">
                                    <template #default="scope">
                                        <el-button circle :icon="Scissor" @click="handleCut(scope.row)" />
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-popover>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12" :padding="20">
                            <el-form-item label="Sql">
                                <template v-slot:label>
                                    Sql
                                    <el-tooltip effect="dark" :content="$t('main.sqlTips')" placement="top">
                                        <InfoFilled style="width: 1em; height: 1em; margin: 5px" />
                                    </el-tooltip>
                                </template>
                                <el-input v-model="inputParam1" :rows="5" maxlength="10000" show-word-limit
                                    type="textarea" :placeholder="$t('main.pleaseInput')" />
                            </el-form-item>

                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Param">
                                <template v-slot:label>
                                    {{ $t("main.param") }}
                                    <el-tooltip effect="dark" :content="$t('main.paramTips')" placement="top">
                                        <InfoFilled style="width: 1em; height: 1em; margin: 5px" />
                                    </el-tooltip>
                                </template>
                                <el-input v-model="inputParam2" :rows="5" maxlength="100000" show-word-limit
                                    type="textarea" :placeholder="$t('main.pleaseInput')" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="Result">
                                <template v-slot:label>
                                    {{ $t("main.result") }}
                                </template>
                                <CodeEditor v-model="code" :options="editorOptions"
                                    :highlightWordConfigs="highlightWordConfigs" />
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-form>
            </el-main>
            <el-backtop :right="100" :bottom="100" />

            <footer>
                <a href="https://beian.miit.gov.cn/#/Integrated/index">粤ICP备2024271700号</a>
            </footer>
        </el-container>
    </div>
</template>

<script setup>

import { ref } from 'vue'
import { ElContainer, ElHeader, ElMain, ElRow, ElCol, ElFormItem, ElInput, ElButton, ElMessage, ElTooltip, ElDropdown, ElDropdownMenu, ElDropdownItem, ElPopover, ElTable, ElTableColumn } from 'element-plus'
import { InfoFilled, Scissor } from '@element-plus/icons-vue'
import { format } from 'sql-formatter';
import { useI18n } from 'vue-i18n';
import CodeEditor from './CodeEditor.vue';
import MarkdownViewer from './MarkdownViewer.vue';
import { onMounted } from 'vue';
import { formatDateTime } from '@/utils/dateUtils';

const { t, locale } = useI18n();
const inputParam1 = ref('')
const inputParam2 = ref('')
const outputParam = ref('')
const inputText = ref('')
const code = ref('');
const editorOptions = ref({
    mode: 'text/x-sql',
    theme: 'default',
    lineNumbers: true
});
const highlightWordConfigs = ref([]);
const markdownContent = ref('')
const historyList = ref([])
const historyVisible = ref(false)

function tryIt() {
    inputParam1.value = 'select * from table where a = ? and b = ? and c = ? and d = ?'
    inputParam2.value = 'a(String),1(Integer),2020-01-01(Timestamp),8.88(BigDecimal)'
}

onMounted(async () => {
    const md = await fetch('/log-zh.md')
    markdownContent.value = await md.text()
})

function submit() {
    if (!inputParam1.value || !inputParam2.value) {
        return;
    }
    inputParam1.value = inputParam1.value.replace(/(\r\n|\n)+/g, '')
    inputParam2.value = inputParam2.value.replace(/(\r\n|\n)+/g, '')

    inputText.value = inputParam1.value

    let paramMatches = inputParam2.value.match(/null|(?:(?!\snull)[\s\S])*?\((String|Integer|Long|Timestamp|BigDecimal|Double)+\)/g)
    let params = []

    for (let i = 0; i < paramMatches.length; i++) {
        let p = paramMatches[i];
        p = p.replace(/^\s+|\s+$|^,\s+|^,/g, "")
        if (p.match(/\((String|Timestamp)+\)/g)) {
            p = "'" + p + "'"
        }
        p = p.replace(/^,/g, '')
        p = p.replace(/\((String|Integer|Long|Timestamp|BigDecimal|Double)+\)/g, '')
        params.push(p)
    }
    // console.log('params: ' + params)

    let results = inputParam1.value.split('?')
    // console.log('results: ' + results.length + ' params: ' + params.length)
    // console.log('highlightConfigs: ' + JSON.stringify(highlightConfigs))

    let result = ''
    if (inputParam1.value.match(/\?/g).length != params.length) {
        ElMessage({
            message: t('main.paramsNotMatch'),
            type: 'error',
        })
        return
    }
    let highlightConfigs = handleHighlightConfig(inputParam1.value, params)

    saveCached(inputParam1.value, inputParam2.value)
    for (let i = 0; i < results.length; i++) {
        if (params[i]) {
            result = result + results[i] + params[i]
        } else {
            result = result + results[i]
        }
    }
    try {
        outputParam.value = format(result, { language: 'mysql' })
    } catch {
        ElMessage({
            message: t('main.paramsError'),
            type: 'error',
        })
        return
    }
    code.value = outputParam.value
    highlightWordConfigs.value = highlightConfigs

    copy()
}

function saveCached(inputParam1, inputParam2) {
    let currentParams = {
        "date": formatDateTime(new Date()),
        "inputParam1": inputParam1,
        "inputParam2": inputParam2
    }
    let cachedHistory = ''
    if (sessionStorage.getItem('sqlHistory')) {
        cachedHistory = sessionStorage.getItem('sqlHistory')._value
    }
    // console.log("cachedHistory " + cachedHistory)
    if (cachedHistory) {
        historyList.value = JSON.parse(cachedHistory)
    }
    if (historyList.value.length >= 5) {
        historyList.value.pop()
    }
    historyList.value.reverse()
    historyList.value.push(currentParams)

    sessionStorage.setItem('sqlHistory', JSON.stringify(historyList))

    historyList.value.reverse()
}

function handleCut(row) {
    inputParam1.value = row.inputParam1
    inputParam2.value = row.inputParam2
    historyVisible.value = false
}

function handleHighlightConfig(inputParam1, params) {
    if (params.length == 0) {
        return []
    }
    let highlightConfigs = []
    const sql = format(inputParam1, { language: 'mysql' })
    const lines = sql.split('\n')
    let paramIndex = 0
    lines.forEach((line, index) => {
        if (line.includes('?')) {
            const lineStrs = line.split('?')
            let prefix = 0
            for (let i = 0; i < lineStrs.length - 1; i++) {
                let highlightConfig = {
                    'word': params[paramIndex],
                    'line': index,
                    'from': lineStrs[i].length + prefix,
                    'to': lineStrs[i].length + params[paramIndex].length + prefix
                }
                prefix += lineStrs[i].length + params[paramIndex].length
                paramIndex++;
                highlightConfigs.push(highlightConfig)
            }
        }

    })

    return highlightConfigs
}

async function copy() {
    try {
        await navigator.clipboard.writeText(outputParam.value);
        ElMessage({
            message: t('main.successMsg'),
            type: 'success',
        })
    } catch (err) {
        console.error('Failed to copy: ', err);
    }
}

function changeLanguage(lang) {
    // console.log('lang: ' + lang)
    locale.value = lang;
    localStorage.setItem('language', lang)
}

</script>


<style lang="scss">
.layout-container-demo .el-header {
    position: relative;
    color: var(--el-text-color-primary);
}

.layout-container-demo .el-aside {
    color: var(--el-text-color-primary);
}

.layout-container-demo .el-menu {
    border-right: none;
}


.layout-container-demo .toolbar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    right: 20px;
}

.layout-container-demo .el-row {
    margin-bottom: 20px;
}

.layout-container-demo .el-row:last-child {
    margin-bottom: 0;
}

.layout-container-demo .el-col {
    border-radius: 4px;
}

.grid-content {
    border-radius: 4px;
    min-height: 36px;
}

.el-row {
    margin-bottom: 20px;
}

.el-row:last-child {
    margin-bottom: 0;
}

.el-col {
    border-radius: 4px;
}

.el-container {
    width: 100%;
    min-height: 100%;
    position: relative;
    flex-direction: column;
    justify-content: space-between;
}

.el-main {
    height: 100%;
    overflow: auto;
}

.el-footer {
    bottom: 0;
    height: 4vh;
    widows: 100%;
    align-items: center;
}

u {
    color: white;
    text-decoration-color: white;
    background-color: #666666;
}

a {
    color: #666666;
    font-size: 14px;
    text-decoration: none;
}

a:hover {
    color: #409eff;
}

.highlighted {
    color: white !important;
    text-decoration-color: white;
    background-color: #BBBBBB;
    border-radius: 5px;
    /* 圆角半径 */
    padding: 2px 4px;
    /* 内边距 */
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    /* 阴影效果 */
    display: inline-block;
    /* 使其适应文本内容 */
}

.CodeMirror {
    border: 1px solid #ddd;
    height: 500px;
    text-align: left;
    font-family: 'Avenir', 'Helvetica', 'Arial', sans-serif;
	height: auto !important;
}

.CodeMirror-scroll {
	height: auto !important;
	min-height: 280px;
}

.footer {
    width: 100%;
    position: absolute;
    bottom: 0;
    margin-bottom: 10px;
}

</style>